import React from "react";

import {
  ASSESSMENT,
  RTE,
  UNIT_FLOW,
  PROGRESS_REPORT,
  ANNOUNCEMENT,
  BEHAVIOR,
  ANNOUNCEMENT_AI,
} from "Constants/stringConstants";

import ConfigureAIVoiceV2 from "./components/ConfigureAIVoiceV2";
import ConfigureAIVoiceV3 from "./components/ConfigureAIVoiceV3";

/*
if FeatureFlag:EnableNewLEVoiceConfiguration is enabled then

-> For RTE and ASSESSMENT
1. make the language common for all modules 
2. Initially set the platform language as default language of AI voice modal
3. Will render only Language and prompt set 

-> For PROGRESS_REPORT
1. make the language common for all modules 
2. Initially set the platform language as default language of AI voice modal
*/
const ConfigureAIVoiceWrapper = props => {
  const { entityType } = props;

  switch (entityType) {
    case ASSESSMENT:
    case RTE:
    case ANNOUNCEMENT:
    case ANNOUNCEMENT_AI:
    case BEHAVIOR: {
      return <ConfigureAIVoiceV2 showLanguageDropdown={true} {...props} />;
    }

    case UNIT_FLOW:
      return <ConfigureAIVoiceV2 showLanguageDropdown={true} {...props} />;

    case PROGRESS_REPORT:
      return <ConfigureAIVoiceV3 {...props} />;

    default:
      return;
  }
};

export default ConfigureAIVoiceWrapper;
